<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Fortalecimento, liderança e expansão</h2>
          <p>
            Com a aquisição da Seara, a JBS se consolida como uma das empresas
            líderes no setor de aves, suínos e alimentos preparados no mercado
            brasileiro. Por meio das marcas
            <strong
              >Seara, Fiesta, Rezende, Massa Leve, LeBon, Doriana,
              Frangosul,</strong
            >
            entre outras, a empresa fortalece suas plataformas de produção,
            inovação e distribuição de alimentos.
          </p>
          <p>
            A JBS se transforma na maior processadora de couro do mundo ao
            adquir a Zenda, empresa líder com sede no Uruguai e operações no
            México, Argentina, Alemanha e África do Sul, além de escritório
            comercial e um centro de distribuição nos Estados Unidos.
          </p>
          <p>
            Na América do Norte, a JBS adquire ativos da
            <strong>XL Foods</strong> nos EUA e Canadá.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2013/2013-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2013/06/09/g/20130609-43699-nac-40-eco-b9-not-qqhxxke.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2013/2013-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2013/12/05/g/20131205-43878-spo-89-gui-d2-not-gxwwpwe.jpg'
              )
            "
            class="secondItem"
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>Vamos pra rua: os <strong>food trucks</strong></h2>
          <p>
            Em 2013, a regulamentação da comida de rua em São Paulo abriu espaço
            para uma nova era dos restaurantes e vontades gastronômicas. Um dos
            alimentos que mais se popularizaram com os chamados
            <strong>food trucks</strong>
            foram os hambúrgueres, trazendo novo impulso ao consumo de carne no
            País.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 440px 1fr 250px;
    gap: 40px;
    justify-content: space-between;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        @include media("<=desktop") {
          padding: 0 20px;
        }
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        span {
          position: absolute;
          left: 20px;
          top: 450px;
          width: 65px;
          color: color(cBlue);
          @include media("<=desktop") {
            top: 300px;
          }
          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media("<=desktop") {
          padding: 40px 20px;
          background: linear-gradient(153deg, #232378 44.8%, #41cdf5 98.84%);
          margin-top: 50px;
        }
        span {
          display: block;
          width: 65px;
          color: color(cBlue);

          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlack);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          span {
            width: initial;
            display: inline;
            font-weight: 400;
          }
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: linear-gradient(153deg, #232378 44.8%, #41cdf5 98.84%);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
